import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../common/icons/ActivateWarranty-Icon.svg'


_pushScopeId("data-v-489d4e63")
const _hoisted_1 = { class: "card p-4" }
const _hoisted_2 = { class: "\n        d-flex\n        py-7-5\n        justify-content-center\n        align-items-center\n        flex-column\n      " }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Activate Warranty"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", {
  class: /*#__PURE__*/_normalizeClass('cera-med')
}, "Activate a Warranty or Code", -1)
const _hoisted_5 = {
  class: "fw-normal",
  style: {"font-family":"'Cera Round Pro Regular', serif","color":"#9ba1ab"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, " Click the button below to activate a warranty for a device ")
], -1)
const _hoisted_7 = { class: "row justify-content-center mt-4" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, " Activate Now ", -1)
const _hoisted_10 = [
  _hoisted_9
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectActivateWarranty(_ctx.CoverageType.ACTIVATE_WARRANTY))),
              primary: "",
              class: "btn btn-primary btn-mobile w-100 text-center"
            }, _hoisted_10)
          ])
        ])
      ])
    ])
  ]))
}